import { StockItemType } from '@/enums/StockItemType';
import { StockMovementType } from '@/enums/StockMovementType';
import { StockUnit } from '@/enums/StockUnit';
import { IDataOptions } from '@/interfaces/IDataOptions';
import { IPaginated } from '@/interfaces/IPaginated';
import { IStockItem } from '@/interfaces/IStockItem';
import { IStockMovement } from '@/interfaces/IStockMovement';
import { Globals } from '@/modules/Globals';
import axios from 'axios';

const apiUrl = Globals.apiPath + '/stock/movements';

export class StockMovementsService {
  static async getAll({
    restaurantId,
    branchId,
    itemType,
    type,
    stockItemId,
    from,
    to,
    options,
  }: {
    restaurantId: number;
    branchId: number;
    itemType?: StockItemType;
    type?: StockMovementType;
    stockItemId?: number;
    /** ISO instants; `to` is exclusive. */
    from?: Date;
    to?: Date;
    options?: IDataOptions;
  }) {
    const res = await axios.get<IPaginated<IStockMovement>>(
      `${apiUrl}?r=${restaurantId}&b=${branchId}` +
        (itemType ? `&itemType=${itemType}` : '') +
        (type ? `&type=${type}` : '') +
        (stockItemId ? `&stockItemId=${stockItemId}` : '') +
        (from ? `&from=${encodeURIComponent(from.toISOString())}` : '') +
        (to ? `&to=${encodeURIComponent(to.toISOString())}` : '') +
        (options
          ? `&options=${encodeURIComponent(JSON.stringify(options))}`
          : '')
    );
    return res.data;
  }
}
